import ArrowLeftIcon from 'assets/icons/ArrowLeftIcon'
import BodyText from 'components/UI/body-text/body-text'
import { Button } from 'components/UI/button/button'
import OtpInput from 'components/UI/otp-input/otp-input'
import SubBody from 'components/UI/sub-body/sub-body'
import { Fragment, ReactNode } from 'react'
import React from 'react'
import CurrencyFormat from 'react-currency-format'
import { Control, FieldValues, Path } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import tw, { TwStyle } from 'twin.macro'

import CountdownTimer from './timer'

type OtpVerificationVariants = 'phone-otp' | 'dd-otp'

type OtpVerificationProps<T extends FieldValues> = {
  variant?: OtpVerificationVariants
  phone?: string
  control: Control<T>
  isOtpValid: boolean
  name: Path<T>
  errorMsg?: string
  disabled?: boolean
  otpLength?: number
  initMinutes?: number
  initSeconds?: number
  showOtp?: boolean
  onOtpVerify?: (value: string | undefined) => void
  onChangePhone?: () => void
  onOtpTimerReset?: () => void
  footerContent?: ReactNode
  twStyle?: TwStyle
  isLoading: boolean
}

/* 
  TODO:Убрать проп variant и оставить только ввод OTP
  Вынести показ текста в разные компоненты так как щас невозможно извне менять содержимое этого компонента
*/
const OtpVerify = <T extends FieldValues>({
  variant = 'phone-otp',
  phone,
  control,
  name,
  errorMsg,
  disabled = false,
  otpLength = 4,
  initMinutes = 0,
  initSeconds = 59,
  showOtp = true,
  onChangePhone,
  onOtpVerify,
  onOtpTimerReset,
  footerContent,
  twStyle,
  isOtpValid,
  isLoading
}: OtpVerificationProps<T>) => {
  const handleOtpVerify = (value: string | undefined) => {
    onOtpVerify?.(value)
  }

  const { t, i18n } = useTranslation('otp')

  return (
    <div tw='flex flex-col items-start gap-5'>
      {showOtp && (
        <Fragment>
          {phone && (
            <div>
              <div tw='mt-3 mb-1 flex items-center gap-1 text-s14'>
                {i18n.language === 'kk' ? (
                  <>
                    <SubBody twStyle={tw`text-secondary`}>
                      {' '}
                      Код{' '}
                      <CurrencyFormat
                        value={phone}
                        displayType={'text'}
                        format='+# ### ### ## ##'
                        tw='text-s14 text-secondary'
                      />{' '}
                      нөміріне жіберілді
                    </SubBody>
                  </>
                ) : (
                  <>
                    <SubBody twStyle={tw`text-secondary`}>{t('send_to')}</SubBody>
                    {phone}
                    {/* <CurrencyFormat
                      value={phone}
                      displayType={'text'}
                      format='+# # ## ##'
                      tw='text-s14 text-secondary'
                    /> */}
                  </>
                )}
              </div>
            </div>
          )}
          <OtpInput
            label={''}
            numInputs={otpLength}
            errorMsg={errorMsg}
            control={control}
            name={name}
            shouldAutoFocus
            disabled={disabled}
            onVerify={handleOtpVerify}
          />
          {/* <CountdownTimer initialMinutes={initMinutes} initialSeconds={initSeconds} onResetTimer={onOtpTimerReset} /> */}
          <Button variant='gradient' disabled={!isOtpValid} loading={isLoading}>
            {t('continue')}
          </Button>
          {onChangePhone && (
            <button onClick={onChangePhone}>
              <SubBody twStyle={tw`text-green-secondary flex items-center`}>
                <ArrowLeftIcon />
                {t('change_phone')}
              </SubBody>
            </button>
          )}
        </Fragment>
      )}
      {footerContent}
    </div>
  )
}

export default OtpVerify
